import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Sidebar from '../../components/Sidebar';
import Topbar from '../../components/Topbar';
import PageHeader from '../../components/PageHeader';
import { AIOutlineButton } from '../../components/ui/AIOutlineButton';
import { AISidebar } from '../../components/AISidebar';
import { AIRecommendationPanel } from '../../components/ai/AIRecommendationPanel';
import { Trophy, BookOpen, Calendar, ArrowRight, Search, ArrowUpDown } from 'lucide-react';
// Mock AI recommendations for LMS Overview
const getLMSOverviewRecommendations = () => [{
  id: '1',
  title: 'Corso Zero Waste 101 molto richiesto',
  type: 'Opportunità',
  diamondRange: '95% completamento',
  reason: "Il corso Zero Waste 101 ha raggiunto il 95% di completamento. Considera di creare un livello avanzato per mantenere l'engagement.",
  ctaLabel: 'Crea corso avanzato'
}, {
  id: '2',
  title: 'Challenge con bassa partecipazione',
  type: 'Attenzione',
  diamondRange: 'Solo 30% partecipazione',
  reason: 'La challenge "Mobilità Sostenibile" ha solo il 30% di partecipazione. Valuta di aumentare i premi o semplificare le prove richieste.',
  ctaLabel: 'Modifica challenge'
}, {
  id: '3',
  title: 'Workshop Compostaggio sold out',
  type: 'Trend',
  diamondRange: 'Esaurito in 2 giorni',
  reason: 'Il Workshop Compostaggio ha esaurito i posti in 2 giorni. Pianifica una seconda data per soddisfare la domanda.',
  ctaLabel: 'Aggiungi data'
}];
// Mock data for recent activity table
const recentActivityData = [{
  id: 1,
  type: 'Prove',
  description: 'Prova inviata',
  user: 'Marco Rossi',
  date: '2 ore fa',
  status: 'In revisione'
}, {
  id: 2,
  type: 'Sondaggi',
  description: 'Sondaggio pubblicato: Preferenze mobilità',
  user: '—',
  date: '5 ore fa',
  status: 'Pubblicato'
}, {
  id: 3,
  type: 'Corsi',
  description: 'Corso aggiornato: Zero Waste 101',
  user: '—',
  date: '1 giorno fa',
  status: 'Aggiornato'
}, {
  id: 4,
  type: 'Challenge',
  description: 'Challenge completata',
  user: 'Giulia Bianchi',
  date: '1 giorno fa',
  status: 'Completata'
}, {
  id: 5,
  type: 'Eventi',
  description: 'Evento creato: Workshop Compostaggio',
  user: '—',
  date: '2 giorni fa',
  status: 'Creato'
}];
// Mock data for upcoming events
const upcomingEvents = [{
  id: 1,
  title: 'Workshop Compostaggio',
  date: '15 Maggio, 18:00',
  location: 'Milano, Green Hub'
}, {
  id: 2,
  title: 'Meetup Community',
  date: '22 Maggio, 19:30',
  location: 'Roma, Eco Space'
}];
const LMSOverview = () => {
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState('');
  const [typeFilter, setTypeFilter] = useState('Tutto');
  const [statusFilter, setStatusFilter] = useState('Tutto');
  const [isAISidebarOpen, setIsAISidebarOpen] = useState(false);
  const recommendations = getLMSOverviewRecommendations().map(rec => ({
    ...rec,
    onCtaClick: () => console.log('CTA clicked:', rec.id)
  }));
  // Filter activity data
  const filteredActivity = recentActivityData.filter(activity => {
    const matchesSearch = activity.description.toLowerCase().includes(searchQuery.toLowerCase()) || activity.user.toLowerCase().includes(searchQuery.toLowerCase());
    const matchesType = typeFilter === 'Tutto' || activity.type === typeFilter;
    const matchesStatus = statusFilter === 'Tutto' || activity.status === statusFilter;
    return matchesSearch && matchesType && matchesStatus;
  });
  return <div className="flex h-screen bg-gray-50" data-id="element-2800">
      <div className="w-20 flex-shrink-0" data-id="element-2801">
        <Sidebar data-id="element-2802" />
      </div>

      <div className="flex-1 flex flex-col overflow-hidden" data-id="element-2803">
        <Topbar data-id="element-2804" />
        <main className="flex-1 overflow-y-auto p-4 md:p-6" data-id="element-2805">
          {/* Page Header with AI Button */}
          <div className="mb-8" data-id="element-2806">
            <div className="flex items-start justify-between" data-id="element-2807">
              <div data-id="element-2808">
                <h1 className="text-2xl font-semibold text-gray-900" data-id="element-2809">
                  Panoramica LMS & Community
                </h1>
                <p className="text-sm font-normal text-gray-500 mt-1" data-id="element-2810">
                  Dashboard sintetica del modulo
                </p>
              </div>
              <AIOutlineButton onClick={() => setIsAISidebarOpen(true)} data-id="element-2811">
                Suggerimenti AI
              </AIOutlineButton>
            </div>
          </div>

          {/* Stats Grid - Reordered: Corsi, Challenge, Eventi */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8" data-id="element-2812">
            {/* Corsi pubblicati */}
            <div className="bg-white rounded-lg border border-gray-200 p-6" data-id="element-2813">
              <div className="flex items-center justify-between mb-4" data-id="element-2814">
                <div className="p-3 bg-gray-50 rounded-lg" data-id="element-2815">
                  <BookOpen className="h-6 w-6 text-gray-400" data-id="element-2816" />
                </div>
                <span className="text-3xl font-bold text-gray-900" data-id="element-2817">8</span>
              </div>
              <h3 className="text-base font-semibold text-gray-900 mb-1" data-id="element-2818">
                Corsi pubblicati
              </h3>
              <p className="text-sm text-gray-500 mb-4" data-id="element-2819">
                Moduli formativi disponibili
              </p>
              <button onClick={() => navigate('/lms/corsi')} className="text-sm font-medium text-green-600 hover:text-green-700 flex items-center" data-id="element-2820">
                Gestisci corsi <ArrowRight className="h-4 w-4 ml-1" data-id="element-2821" />
              </button>
            </div>

            {/* Challenge attive */}
            <div className="bg-white rounded-lg border border-gray-200 p-6" data-id="element-2822">
              <div className="flex items-center justify-between mb-4" data-id="element-2823">
                <div className="p-3 bg-gray-50 rounded-lg" data-id="element-2824">
                  <Trophy className="h-6 w-6 text-gray-400" data-id="element-2825" />
                </div>
                <span className="text-3xl font-bold text-gray-900" data-id="element-2826">4</span>
              </div>
              <h3 className="text-base font-semibold text-gray-900 mb-1" data-id="element-2827">
                Challenge attive
              </h3>
              <p className="text-sm text-gray-500 mb-4" data-id="element-2828">
                Sfide in corso per gli utenti
              </p>
              <button onClick={() => navigate('/lms/programmazione')} className="text-sm font-medium text-green-600 hover:text-green-700 flex items-center" data-id="element-2829">
                Gestisci challenge <ArrowRight className="h-4 w-4 ml-1" data-id="element-2830" />
              </button>
            </div>

            {/* Prossimo evento */}
            <div className="bg-white rounded-lg border border-gray-200 p-6" data-id="element-2831">
              <div className="flex items-center justify-between mb-4" data-id="element-2832">
                <div className="p-3 bg-gray-50 rounded-lg" data-id="element-2833">
                  <Calendar className="h-6 w-6 text-gray-400" data-id="element-2834" />
                </div>
                <span className="text-3xl font-bold text-gray-900" data-id="element-2835">
                  {upcomingEvents.length}
                </span>
              </div>
              <h3 className="text-base font-semibold text-gray-900 mb-1" data-id="element-2836">
                Prossimo evento
              </h3>
              {upcomingEvents.length > 0 ? <>
                  <p className="text-sm text-gray-500 mb-4" data-id="element-2837">
                    {upcomingEvents[0].title}
                  </p>
                  <div className="text-xs text-gray-500 mb-4" data-id="element-2838">
                    {upcomingEvents[0].date} • {upcomingEvents[0].location}
                  </div>
                </> : <p className="text-sm text-gray-500 mb-4" data-id="element-2839">
                  Nessun evento in programma
                </p>}
              <button onClick={() => navigate('/lms/programmazione')} className="text-sm font-medium text-green-600 hover:text-green-700 flex items-center" data-id="element-2840">
                Vedi tutti <ArrowRight className="h-4 w-4 ml-1" data-id="element-2841" />
              </button>
            </div>
          </div>

          {/* Recent Activity Table */}
          <div className="bg-white rounded-lg border border-gray-200 overflow-hidden" data-id="element-2842">
            <div className="px-6 py-4 border-b border-gray-200" data-id="element-2843">
              <h3 className="text-lg font-semibold text-gray-900 mb-4" data-id="element-2844">
                Attività recente
              </h3>

              {/* Filters */}
              <div className="flex flex-col md:flex-row gap-4" data-id="element-2845">
                <div className="relative flex-1" data-id="element-2846">
                  <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-gray-400" data-id="element-2847" />
                  <input type="text" placeholder="Cerca per utente o contenuto..." value={searchQuery} onChange={e => setSearchQuery(e.target.value)} className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-600 focus:border-transparent text-sm" data-id="element-2848" />
                </div>
                <select value={typeFilter} onChange={e => setTypeFilter(e.target.value)} className="px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-600 focus:border-transparent text-sm" data-id="element-2849">
                  <option value="Tutto" data-id="element-2850">Tipo: Tutto</option>
                  <option value="Prove" data-id="element-2851">Prove</option>
                  <option value="Sondaggi" data-id="element-2852">Sondaggi</option>
                  <option value="Corsi" data-id="element-2853">Corsi</option>
                  <option value="Challenge" data-id="element-2854">Challenge</option>
                  <option value="Eventi" data-id="element-2855">Eventi</option>
                </select>
                <select value={statusFilter} onChange={e => setStatusFilter(e.target.value)} className="px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-600 focus:border-transparent text-sm" data-id="element-2856">
                  <option value="Tutto" data-id="element-2857">Stato: Tutto</option>
                  <option value="Inviata" data-id="element-2858">Inviata</option>
                  <option value="In revisione" data-id="element-2859">In revisione</option>
                  <option value="Approvata" data-id="element-2860">Approvata</option>
                  <option value="Non valida" data-id="element-2861">Non valida</option>
                  <option value="Pubblicato" data-id="element-2862">Pubblicato</option>
                  <option value="Aggiornato" data-id="element-2863">Aggiornato</option>
                  <option value="Creato" data-id="element-2864">Creato</option>
                  <option value="Completata" data-id="element-2865">Completata</option>
                </select>
              </div>
            </div>

            {/* Table */}
            {filteredActivity.length > 0 ? <div className="overflow-x-auto" data-id="element-2866">
                <table className="w-full" data-id="element-2867">
                  <thead className="bg-gray-50" data-id="element-2868">
                    <tr data-id="element-2869">
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2870">
                        <button className="flex items-center gap-1 hover:text-gray-700" data-id="element-2871">
                          Tipo <ArrowUpDown className="h-3 w-3" data-id="element-2872" />
                        </button>
                      </th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2873">
                        Descrizione
                      </th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2874">
                        Utente
                      </th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2875">
                        <button className="flex items-center gap-1 hover:text-gray-700" data-id="element-2876">
                          Data <ArrowUpDown className="h-3 w-3" data-id="element-2877" />
                        </button>
                      </th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2878">
                        Stato
                      </th>
                      <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2879">
                        Azione
                      </th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-200" data-id="element-2880">
                    {filteredActivity.map(activity => <tr key={activity.id} className="hover:bg-gray-50" data-id="element-2881">
                        <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900" data-id="element-2882">
                          {activity.type}
                        </td>
                        <td className="px-6 py-4 text-sm text-gray-900" data-id="element-2883">
                          {activity.description}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-2884">
                          {activity.user}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-2885">
                          {activity.date}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap" data-id="element-2886">
                          <span className="px-2 py-1 text-xs font-medium rounded-full bg-gray-100 text-gray-700" data-id="element-2887">
                            {activity.status}
                          </span>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-right text-sm" data-id="element-2888">
                          <button className="text-green-600 hover:text-green-700 font-medium" data-id="element-2889">
                            Apri
                          </button>
                        </td>
                      </tr>)}
                  </tbody>
                </table>
              </div> : <div className="px-6 py-12 text-center" data-id="element-2890">
                <p className="text-gray-500 mb-2" data-id="element-2891">
                  Nessuna attività da mostrare.
                </p>
                {(searchQuery || typeFilter !== 'Tutto' || statusFilter !== 'Tutto') && <button onClick={() => {
              setSearchQuery('');
              setTypeFilter('Tutto');
              setStatusFilter('Tutto');
            }} className="text-sm text-green-600 hover:underline" data-id="element-2892">
                    Rimuovi filtri
                  </button>}
              </div>}
          </div>
        </main>
      </div>

      {/* AI Sidebar */}
      <AISidebar isOpen={isAISidebarOpen} onClose={() => setIsAISidebarOpen(false)} title="Suggerimenti AI: LMS Overview" data-id="element-2893">
        <AIRecommendationPanel recommendations={recommendations} data-id="element-2894" />
      </AISidebar>
    </div>;
};
export default LMSOverview;